var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RbText hSpace hSpace--app",class:_vm.elmClasses},[_c('div',{staticClass:"RbText__inner richText font font--sans",class:_vm.elmInnerClasses,domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }